export default "__VITE_ASSET__CwCE0uOF__"